export function getCurrentContract() {
  const contract = localStorage.getItem("currentContract");

  if (!contract || contract === 'undefined' || contract === undefined) {
    return {}; // Retorna um objeto vazio
  }

  return JSON.parse(contract);
}


export function getCurrentComponent() {
  const component = localStorage.getItem("currentComponent")

  if (!component) {
    return 'PrincipalCard';
  }

  return component;
}

export function getAllContracts() {
  const contracts = localStorage.getItem("allContracts")

  if (!contracts) {
    return null;
  }

  return JSON.parse(contracts);
}
